
export class CurrentPage {
  header = '';
  description = '';
  page = '';
  nextUrl = '';
  onBoardingStatus: 'start' | 'employees' | 'devices' | 'syncapp' | 'alerts' | 'complete' = 'start';
}




// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/push-events.ts